import { actions } from './actions';
import * as sagas from './sagas';
export const bookModel = { actions, sagas };
